import { Routes } from '@angular/router';

import { SERVICE_ANALYTICS } from '../shared/models/list';

import { EFeasibilityComponent } from './components/efeasibility.component';
import { efeasibilityUserGuard } from './guards/efeasibility-user.guard';

export const routes: Routes = [
	{
		path: '',
		redirectTo: 'dashboard',
		pathMatch: 'full',
		data: { pageName: 'Redirect' }
	},
	{
		path: 'dashboard',
		component: EFeasibilityComponent,
		data: { pageName: 'eFeasibility - Dashboard', service: SERVICE_ANALYTICS.EFEASIBILITY },
		canActivate: [efeasibilityUserGuard]
	}
];
